import React, { useState } from 'react';
import {Cell, Pie, PieChart, ResponsiveContainer, Sector} from 'recharts';

const renderActiveShape = props => {
    const RADIAN = Math.PI / 180;
    const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload, percent, value } = props;
    const sin = Math.sin(-RADIAN * midAngle);
    const cos = Math.cos(-RADIAN * midAngle);
    const sx = cx + (outerRadius + 10) * cos;
    const sy = cy + (outerRadius + 10) * sin;
    const mx = cx + (outerRadius + 30) * cos;
    const my = cy + (outerRadius + 30) * sin;
    const ex = mx + (cos >= 0 ? 1 : -1) * 22;
    const ey = my;
    const textAnchor = cos >= 0 ? 'start' : 'end';

    return (
        <g>
            <text x={cx} y={cy} dy={8} textAnchor="middle" fill={"#181717"}>
                    <>{payload.name}</>
            </text>
            <Sector
                cx={cx}
                cy={cy}
                innerRadius={innerRadius}
                outerRadius={outerRadius}
                startAngle={startAngle}
                endAngle={endAngle}
                fill={fill}
            />


            {(payload.name !== "None Detected" && payload.name !== "Loading...") &&
                <>
                    <Sector
                        cx={cx}
                        cy={cy}
                        startAngle={startAngle}
                        endAngle={endAngle}
                        innerRadius={outerRadius + 6}
                        outerRadius={outerRadius + 10}
                        fill={fill}
                    />
                    <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
                    <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
                    <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} textAnchor={textAnchor} fill="#333">{`${value}`}</text>
                    <text x={ex + (cos >= 0 ? 1 : -1) * 12} y={ey} dy={18} textAnchor={textAnchor} fill="#999">
                        {`${(percent * 100).toFixed(0)}%`}
                    </text>
                </>
            }
        </g>
    );
};

const CustomActiveShapePieChart = (props) => {
    const {
        data,
        riskBy5,
        loading = false,
        useRiskCategoryColors = false,
        useTwoNumberGrayColors = false,
        useMonoColors = false,
        name = null,
    } = props;

    const [activeIndex, setActiveIndex] = useState(useTwoNumberGrayColors ? 1 : 0);


    const lowest =  "#00863B";
    const low = "#5FBA15";
    const medium = "#EDEA34";
    const high = "#F28722";
    const highest = "#F6101F";

    /* BreachBits BreachRisk Brand Colors */
    //todo: update these for 2024
    // const brThemeColor0 = "#263440";
    // const brThemeColor1 = "#326a8c";
    // const brThemeColor2 = "#d9d9d9";
    // const brThemeColor3 = "#D9C484";
    // const brThemeColor4 = "#a67272";
    // const brThemeColor5 = "#4b4c4c";
    // const brThemeColor6 = "#8f8640";
    // const brThemeColor7 = "#5e1513";
    // const brThemeColor8 = "#9a9bab";
    // const brThemeColor9 = "#413c62";

    const brThemeColor0 = "#0B154D";
    const brThemeColor1 = "#28368B";
    const brThemeColor2 = "#d9d9d9";
    const brThemeColor3 = "#DBEB2E";
    const brThemeColor4 = "#0B154D";
    const brThemeColor5 = "#4b4c4c";
    const brThemeColor6 = "#69A5FF";
    const brThemeColor7 = "#949E20";
    const brThemeColor8 = "#9a9bab";
    const brThemeColor9 = "#28368B";

    const COLORS = {
        "Highest Risk" : highest,
        "High Risk" : high,
        "Medium Risk" : medium,
        "Low Risk" : low,
        "Lowest Risk" : lowest
    }

    const BR_BRAND_COLORS = [
        brThemeColor0,
        brThemeColor1,
        brThemeColor2,
        brThemeColor3,
        brThemeColor4,
        brThemeColor5,
        brThemeColor6,
        brThemeColor7,
        brThemeColor8,
        brThemeColor9
    ]

    const BR_BRAND_TWO_COLOR = [
        brThemeColor8,
        brThemeColor1
    ]

    let colorForChart = "#A6A6A6"

    switch (riskBy5){
        case 0:
            colorForChart = lowest;
            break;
        case 1:
            colorForChart = low;
            break;
        case 2:
            colorForChart = medium;
            break;
        case 3:
            colorForChart = high;
            break;
        case 4:
            colorForChart = highest;
            break;
        default:
            break;
    }



    const chartData = data.length > 0 && !loading ? data : [{ name: loading ? "Loading..." : 'None Detected', value: 1 },]



    const onPieEnter = (chartData, index) => {
        // console.log("mouseover pie area")
        setActiveIndex(index);
    };

    return (
        <ResponsiveContainer minHeight={300} maxHeight={500} minWidth={400}>
            <PieChart>
                <Pie
                    dataKey="value"
                    activeIndex={activeIndex}
                    activeShape={renderActiveShape}
                    onMouseEnter={onPieEnter}
                    data={chartData}
                    innerRadius={useTwoNumberGrayColors ? 40 : 65}
                    outerRadius={useTwoNumberGrayColors ? 100 : 100}
                    fill={colorForChart}
                    startAngle = {useTwoNumberGrayColors ? 450 : 0}
                    endAngle = {useTwoNumberGrayColors ? 90 : 360}
                    name={name ? name : null}
                >
                    {useRiskCategoryColors
                        ? data.map((entry, index) => (
                            <Cell key={`cell-${index}`} fill={COLORS[entry.name]} />
                            ))
                        : useMonoColors
                            ? null
                            : useTwoNumberGrayColors
                                ? data.map((entry, index) => (
                                    <Cell key={`cell-${index}`}  fill={BR_BRAND_TWO_COLOR[index % BR_BRAND_TWO_COLOR.length]} />
                                ))
                                : data.map((entry, index) => (
                                <Cell key={`cell-${index}`}  fill={BR_BRAND_COLORS[index % BR_BRAND_COLORS.length]} />
                            ))
                    }

                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
};

export default CustomActiveShapePieChart;
